import React from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import {
    Button,
    // Spinner
} from 'reactstrap'
import {
    // ArrowCircleDown,
    ArrowCircleRight,
    Medal,
    // ShoppingCart
} from "phosphor-react"
import Cookies from 'universal-cookie'
import ExamTimeLeftProgressBar from '../UI/ExamTimeLeftProgressBar'
const cookies = new Cookies()
// eslint-disable-next-line no-undef
const imageUrl = process.env.REACT_APP_IMAGEURL

class ExamCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            addToCartAction: false,
        }
        this.routeToCourse = this.routeToCourse.bind(this)
        this.routeToReadMore = this.routeToReadMore.bind(this)
        // this.addToCart = this.addToCart.bind(this)
        this.activateBtn = this.activateBtn.bind(this)
    }

    routeToCourse() {
        // const isDownGradeShow = this.props.userGrade && this.props.userGrade.downGrade && this.props.userGrade.downGrade.show
        // const accessStatusFalse = this.props.access && this.props.access.status === false
        // if (isDownGradeShow || accessStatusFalse) {
        //     return this.routeToReadMore()
        // }
        if (this.props.status.percent >= 100) {
            this.props.props.history.push(`/course/${this.props.id}/mod/${this.props.themes[0].modules[0].id}`)
        } else {
            this.props.props.history.push(this.props.link)
        }
    }

    routeToReadMore() {
        this.props.props.history.push(`/item/${this.props.catalog.id}`)
    }

    // addToCart(event) {
    //     event.preventDefault()
    //     this.setState({ addToCartAction: true })
    //     const button = event.target.closest('.btn.catalog-btn.primary.addToCart')
    //     if (button.classList.contains('active')) {
    //         this.props.props.history.push('/cart')
    //     } else {
    //         this.activateBtn(button)
    //         const items = cookies.get('order') || []
    //         items.push({
    //             userId: cookies.get('userId'),
    //             itemId: this.props.id,
    //         })
    //         cookies.set('order', items, { path: '/' })
    //         this.setState({ addToCartAction: false })
    //     }
    // }

    activateBtn(button) {
        const circle = button.querySelector('.circle-down-icon')
        const cart = button.querySelector('.shopping-cart-icon')
        const text = button.querySelector('.news-btn-desc')
        button.classList.add('active')
        circle.classList.add('d-none')
        cart.classList.remove('d-none')
        text.innerHTML = this.props.t('catalog-order')
    }

    componentDidMount() {
        if (!this.props.access.status) {
            const ordered = cookies.get('order') || []
            ordered.forEach((item) => {
                if (item.itemId === this.props.id) {
                    const card = document.querySelector(`#item-${this.props.id}`)
                    const button = card.querySelector('.btn.catalog-btn.primary.addToCart')
                    this.activateBtn(button)
                }
            })
        }
    }

    render() {
        const { t } = this.props
        const isCurrentGradeActive = this.props.userGrade && this.props.userGrade.current && this.props.userGrade.current.active
        const isCurrentGradeUndefined = this.props.userGrade && this.props.userGrade.current && this.props.userGrade.current.active === undefined
        const isDownGradeShow = this.props.userGrade && this.props.userGrade.downGrade && this.props.userGrade.downGrade.show
        return (
            <div className="col-12">
                <div className="col-12 card course-card" id={`item-${this.props.id}`}>
                    <div className='card-img-wrapper'>
                        <div className="card-type xs-font-size">{t('catalog-type-exam')}</div>
                                        
                        <img className="card-img" src={this.props.image ? `${imageUrl}/${this.props.image}` : "data:,"} alt="" onClick={() => {
                            if(!this.props.blocked && !this.props.status.completed) this.routeToCourse()
                        }}></img>
                        {
                            this.props.medal ?
                                <img
                                    className="certificate"
                                    src={this.props.medal}
                                    alt=""
                                    width="55"
                                    height="55"
                                    onClick={() => this.props.certificate.file ? window.open(`${imageUrl}/certificates/${this.props.certificate.file}`, '_blank') : () => { }}
                                /> :
                                ''
                        }
                    </div>
                    <div className="card-body-wrapper">
                        <div className="card-body">
                            <div className="card-title lg-font-size">{this.props.title}</div>
                            {this.props.programTitle && <div className="md-font-size pt-2">{this.props.programTitle}</div>}
                        </div>
                        <div className="card-whitespace"></div>
                        <div className="card-bottom">
                            {
                                this.props.access.attempts.total ? 
                                    <div className="progress-text">
                                        <span className="text xs-font-size">{t('study-learn-attempts')}</span>
                                        <span className="number md-font-size">{this.props.access.attempts.left}/{this.props.access.attempts.total}</span>
                                    </div>:
                                    ''
                            }
                            {
                                this.props.certificate && this.props.certificate.file ?
                                    <Button
                                        type="button"
                                        className="btn profile-avatar-btn white p-10-20px"
                                        onClick={() => window.open(`${imageUrl}/certificates/${this.props.certificate.file}`, '_blank')}
                                    >
                                        <div className="d-flex align-items-center">
                                            <Medal size={20} />
                                            <span className="pl-5px sm-font-size">{t('certificate-see-more')}</span>
                                        </div>
                                    </Button> : ''
                            }
                            {
                                this.props.showExtendButton ?
                                    <Button
                                        type="button"
                                        className="btn profile-avatar-btn grey p-10-20px"
                                        onClick={this.routeToReadMore}
                                        disabled={!this.props.catalog || !this.props.catalog.id}
                                    >
                                        <div className="d-flex align-items-center">
                                            <ArrowCircleRight size={20} />
                                            <span className="pl-5px sm-font-size">{t('catalog-extend')}</span>
                                        </div>
                                    </Button>
                                    : ''
                            }
                            {
                                this.props.showStartButton ? 
                                    <Button
                                        type="button"
                                        className="btn profile-avatar-btn grey p-10-20px"
                                        onClick={this.routeToCourse}
                                        disabled={this.props.blocked}
                                    >
                                        <div className="d-flex align-items-center">
                                            <ArrowCircleRight size={20} />
                                            <span className="pl-5px sm-font-size">{t('study-start-exam')}</span>
                                        </div>
                                    </Button> 
                                    : ''
                                    
                            }
                        </div>
                        { !isCurrentGradeActive && !isCurrentGradeUndefined ? <ExamTimeLeftProgressBar text={t('study-certificate-expired')}/> : '' }
                        {
                            isDownGradeShow && isCurrentGradeActive ? <ExamTimeLeftProgressBar text={t('study-certificate-expires')} {...this.props.userGrade.downGrade.time.left} /> : ''
                        }
                        { !this.props.complete ? <ExamTimeLeftProgressBar text={t('study-access-available')} {...this.props.access.time.left} /> : '' }
                    </div>
                </div>
            </div>
        )
    }
}

ExamCard.propTypes = {
    link: PropTypes.string,
    medal: PropTypes.string,
    status: PropTypes.object,
    i18n: PropTypes.object,
    t: PropTypes.func,
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    access: PropTypes.object,
    catalogType: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    props: PropTypes.object,
    image: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    tags: PropTypes.array,
    partners: PropTypes.array,
    totalPartners: PropTypes.number,
    likes: PropTypes.number,
    themes: PropTypes.array,
    type: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    match: PropTypes.object,
    programTitle: PropTypes.string,
    blocked: PropTypes.bool,
    certificate: PropTypes.object,
    activeTags: PropTypes.array,
    toggleBtn: PropTypes.func,
    addToFilters: PropTypes.func,
    skeleton: PropTypes.bool,
    catalog: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.any,
    ]),
    userGrade: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.any,
    ]),
    complete: PropTypes.bool,
    showExtendButton: PropTypes.bool,
    showStartButton: PropTypes.bool,
}

export default withTranslation()(ExamCard)



// WEBPACK FOOTER //
// ./src/components/Study/ExamCard.jsx